import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getEventList = async (param) => {
  const baseUrl = `${API_CONSTANTS.EVENT}/list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const addEvent = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let response = await dataAccess.post(`${API_CONSTANTS.EVENT}/add`, payload);
  return response;
};
export const updateEvent = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.EVENT}/update?eventsDetailId=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };
  let response = await dataAccess.put(url, payload);
  return response;
};

export const getEventById = async (id) => {
  let url = `${API_CONSTANTS.EVENT}/detail?eventsDetailId=${id}`;

  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export const deleteEvent = async (id) => {
  let url = `${API_CONSTANTS.EVENT}/delete?eventsDetailId=${id}`;
  let payload = {
    data: {
      id: id,
    },
  };
  let responseObj = await dataAccess.del(url, payload);
  return responseObj;
};
export async function uplaodMedia(file) {
  let formData = new FormData();
  formData.append('image', file);
  let payload = {
    data: formData,
  };

  let responseObj = await dataAccess.upload(
    `${API_CONSTANTS.MEDIA_UPLOAD}`,
    payload
  );

  return responseObj;
}
